export default __webpack_public_path__ + "static/media/accept-icon.3dd02426.svg";